module.exports = __webpack_public_path__ + "static/media/06_a_background.7dd04d22.png";